export default __webpack_public_path__ + "static/media/class_seniors.c4732c94.jpeg";